import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-popconfirm-error",
  "use": "icon-icon-popconfirm-error-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-icon-popconfirm-error\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h16v16H0z\" /><circle fill=\"#EF8600\" cx=\"8\" cy=\"8\" r=\"6.667\" /><path d=\"M7.051 4.667h1.898a.333.333 0 0 1 .33.38l-.612 4.286H7.333l-.612-4.286a.333.333 0 0 1 .33-.38zM7.334 10h1.333v1.333H7.334z\" fill=\"#FFF\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol